var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetirementPlan = function SvgRetirementPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#retirement-plan_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.302 4.19 21.185 5c-1.227.194-1.85.82-2.074 2l-1.037 5.5h-3.111l.505-2.644.888-4.129c.349-1.62 1.58-2.96 3.274-3.227l6.222-1c.565-.09.944.455 1.037 1 .167.981-.022 1.6-.587 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 18 2.322-4.926a1 1 0 0 1 .905-.574h21.546a1 1 0 0 1 .905.574L30 18s-.701 2.5-3.63 2.5c-3.63 0-5.185-3.429-5.185-3.429S19.63 20.5 16 20.5s-5.185-3.429-5.185-3.429S9.259 20.5 5.63 20.5C3.037 20.5 2 18 2 18",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 18c0 8.59 6.268 15.5 14 15.5S30 26.59 30 18c0 0-.701 2.5-3.63 2.5-3.63 0-5.185-3.429-5.185-3.429s-1.555 3.43-5.185 3.43-5.185-3.43-5.185-3.43-1.556 3.43-5.185 3.43C3.037 20.5 2 18 2 18",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retirement-plan_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h32v33H0z"
  })))));
};
export default SvgRetirementPlan;